import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/admin.svg'


const _withScopeId = n => (_pushScopeId("data-v-a7378324"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "user" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "user__admin",
  alt: "Admin"
}
const _hoisted_5 = { class: "user__info" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = {
  key: 0,
  class: "justify-end"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "justify-end"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "justify-end"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 3,
  class: "justify-end"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-wrapper info-black" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-move" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 4,
  class: "justify-end"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-message" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 5,
  class: "justify-end"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 6,
  class: "justify-end"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-message-circle" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 2,
  class: "btn-wrapper info-black"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-dots" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 7,
  class: "justify-end"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_spaces_manage_pop_up = _resolveComponent("spaces-manage-pop-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "user__photo",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewProfile && _ctx.viewProfile(...args)))
        }, [
          _createVNode(_component_app_lazy_image, {
            url: _ctx.photoUrl,
            key: _ctx.photoUrl
          }, null, 8, ["url"]),
          (_ctx.user.type === _ctx.USER_TYPE.ADMIN || _ctx.user.type === _ctx.USER_TYPE.OWNER)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", {
            class: "bold",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.messageContact && _ctx.messageContact(...args)))
          }, _toDisplayString(_ctx.fullName), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.user.speciality), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.type === _ctx.NETWORK_CONTACT_TYPES.INVITATION)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "btn-wrapper info",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rejectContact && _ctx.rejectContact(...args)))
              }, _hoisted_10),
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.acceptContact && _ctx.acceptContact(...args)))
              }, _hoisted_12)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === _ctx.NETWORK_CONTACT_TYPES.GROUP_REQUESTS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "btn-wrapper info",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rejectUserToGroup && _ctx.rejectUserToGroup(...args)))
              }, _hoisted_15),
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.acceptUserToGroup && _ctx.acceptUserToGroup(...args)))
              }, _hoisted_17)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === _ctx.NETWORK_CONTACT_TYPES.SUGGESTION)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.requestContact && _ctx.requestContact(...args)))
              }, _hoisted_20)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === _ctx.NETWORK_CONTACT_TYPES.OUTCOMING)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
          : _createCommentVNode("", true),
        (_ctx.type === _ctx.NETWORK_CONTACT_TYPES.MY)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", {
                class: "btn-wrapper primary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.messageContact && _ctx.messageContact(...args)))
              }, _hoisted_26)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === _ctx.NETWORK_CONTACT_TYPES.MANAGE)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", {
                class: "btn-wrapper info-black",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.deleteContact && _ctx.deleteContact(...args)))
              }, _hoisted_29)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === _ctx.NETWORK_CONTACT_TYPES.GROUP_MANAGE && _ctx.user.accountId !== _ctx.mainStore.user.accountId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              (_ctx.user.contactStatus === _ctx.CONTACT_STATUS.CONTACT)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "btn-wrapper primary",
                    to: '/messages/' + _ctx.user.accountId,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close-group-info')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              (_ctx.user.contactStatus === _ctx.CONTACT_STATUS.NO_CONTACT)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "btn-wrapper primary",
                    onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestContact && _ctx.requestContact(...args)), ["prevent"]))
                  }, _hoisted_33))
                : _createCommentVNode("", true),
              (_ctx.user.contactStatus === _ctx.CONTACT_STATUS.REQUEST_SENT)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                : _createCommentVNode("", true),
              (_ctx.groupInfo.ownerId === _ctx.mainStore.user.accountId || _ctx.currentUserIsAdmin)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "btn-wrapper info-dots",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showManagePopUp = true))
                  }, _hoisted_38))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === _ctx.NETWORK_CONTACT_TYPES.GROUP_INVITATION)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", {
                class: _normalizeClass(["btn-wrapper info-black", { clicked: _ctx.isUserSelected }]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('handle-user', _ctx.user.accountId)))
              }, _hoisted_41, 2)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showManagePopUp && _ctx.groupInfo)
      ? (_openBlock(), _createBlock(_component_spaces_manage_pop_up, {
          key: 0,
          user: _ctx.user,
          "group-info": _ctx.groupInfo,
          "current-user-is-admin": _ctx.currentUserIsAdmin,
          onOnUserUpdate: _ctx.handleUserUpdate,
          onHide: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showManagePopUp = false)),
          onCloseGroupInfo: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('close-group-info')))
        }, null, 8, ["user", "group-info", "current-user-is-admin", "onOnUserUpdate"]))
      : _createCommentVNode("", true)
  ]))
}